import styled from 'styled-components';

export const FormButton = styled.div<{ invert?: boolean; color: string }>`
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  border-radius: 10px;
  border: ${({ invert, color }) => (invert ? `2px solid ${color}` : 'none')};
  background-color: ${({ invert: inverted, color }) =>
    inverted ? '#f7f9fb' : color};
  cursor: pointer;
  color: ${({ invert }) => (invert ? '#444444' : '#ffffff')};
  text-transform: uppercase;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.1);
`;
